module.exports = kolibriCoreAppGlobal.coreVue.components.CoreBase;